"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UiNaniClubRedirect = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UiNaniClubRedirect = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 100%;\n\theight: 100vh;\n\n\t.wrapper {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tpadding: 32px 40px;\n\t\tflex-direction: column;\n\t\tbackground-color: #fff;\n\t\tborder-radius: 5px;\n\t}\n\n\t.iconBox {\n\t\ti {\n\t\t\tfont-size: 72px;\n\t\t\tcolor: #ff4d4f;\n\t\t}\n\t}\n\n\t.title {\n\t\tmargin: 8px 0;\n\t\tfont-size: 24px;\n\t}\n\n\t.message {\n\t\tmargin-bottom: 16px;\n\t\tcolor: #98989e;\n\t}\n"])));

exports.UiNaniClubRedirect = UiNaniClubRedirect;